<template>
  <b-th v-if="isColspan" :colspan="field.colspanNum[level]">{{field.colspanLabel[level]}}</b-th>
  <b-th v-else></b-th>
</template>

<script>
export default {
  name: 'thWrap',
  components: {
  },
  
  props: {
    field: Object,
    level: Number,
  },

  computed: {
    isColspan(){
      const vm = this
      return ('colspanNum' in vm.field) && (vm.field.colspanNum[vm.level] > 0)
    },
  }
}
</script>

<style>

</style>